module.exports = __webpack_public_path__ + "static/steam-a1b4f21631bc8adf263505699eb87667.jpg";